import { render, staticRenderFns } from "./RipaStopReason.vue?vue&type=template&id=6111754c"
import script from "./RipaStopReason.vue?vue&type=script&lang=js"
export * from "./RipaStopReason.vue?vue&type=script&lang=js"
import style0 from "./RipaStopReason.vue?vue&type=style&index=0&id=6111754c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports